"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _fa = require("react-icons/fa6");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Dependencies

// Main class export
class LearnMore extends _react.default.Component {
  renderImg() {
    // Don't render the image if there is no src
    if (!this.props.logoSrc) {
      return false;
    }
    return /*#__PURE__*/_react.default.createElement("a", null, /*#__PURE__*/_react.default.createElement("img", {
      style: {
        height: '20px',
        marginTop: '-8px'
      },
      className: "sap-logo",
      alt: this.props.logoAlt || '',
      src: encodeURI(this.props.logoSrc)
    }));
  }
  renderLink() {
    // Don't render link without text and an href
    if (!this.props.learnHref || !this.props.learnText) {
      return false;
    }
    return /*#__PURE__*/_react.default.createElement("a", {
      href: encodeURI(this.props.learnHref)
    }, this.props.learnText, /*#__PURE__*/_react.default.createElement(_fa.FaAngleRight, null));
  }
  render() {
    if (!this.props.learnHref || !this.props.learnText || !this.props.text) {
      return false;
    }
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", {
      className: "footer-learn-more",
      style: this.props.textStyles ? this.props.textStyles : {}
    }, this.renderImg(), /*#__PURE__*/_react.default.createElement("span", {
      style: {
        color: '#fff',
        fontWeight: '300',
        padding: '0 7px 0 2px'
      },
      className: "sap-text"
    }, this.props.text), this.renderLink()));
  }
}
exports.default = LearnMore;
;
LearnMore.propTypes = {
  logoAlt: _propTypes.default.string,
  logoSrc: _propTypes.default.string,
  text: _propTypes.default.string,
  learnHref: _propTypes.default.string,
  learnText: _propTypes.default.string,
  textStyles: _propTypes.default.object
};